import Axios from "axios";
import Auth from './utils/auth/authorization'
import routes from "./routes";
import store from "./store";
import { showNotification } from "./store/reducers/slices/notification.slice";

const axios = Axios.create({
  baseURL: process.env.REACT_APP_API_ENDPOINT,
});

axios.interceptors.request.use(function (config) {
  const accessToken = Auth.getAccessToken();
  if (accessToken) {
    config.headers.Authorization = "Bearer " + accessToken;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => {
    return new Promise((resolve, reject) => {
      if (response.status === 200 || response.status === 201) {
        resolve(response)
      }else{
        reject(response)
      }
    })
  },
  (error) => {
    if (error.response && error.response.status && error.response.status === 401) {
      Auth.logout();
      store.dispatch(showNotification({ message: "Session expired, please login again", type: "error" }));
      store.dispatch({ type: "auth/logout" });
      routes.navigate('/')
      return;
    }
    return Promise.reject(
      (error.response && error.response.data) ? error.response.data : "Something went wrong"
    )
  }
);

export default axios;
